import axios from 'axios';
import store from '@/store';
import {
    authenticationService
} from "@/_services";

const Api = axios.create({
    baseURL: process.env.VUE_APP_API,
    withCredentials: false,
    headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json',
    },
});

Api.interceptors.request.use((config) => {
    store.commit('ADD_PENDING', config.url.hashCode());

    const currentUser = authenticationService.currentUserValue;
    const selectedTenant = localStorage.getItem('selectedTenantId');
    const selectedMp = localStorage.getItem('selectedMpId');

    if (currentUser) {
        config.headers.Authorization = `Bearer ${currentUser.token}`;
        config.headers.TenantId = selectedTenant || currentUser.tenantId;
        config.headers.MpId = selectedMp || currentUser.mpId;
    }

    return config;
});

Api.interceptors.response.use((c) => {
    store.commit('REMOVE_PENDING', c.config.url.hashCode());
    return c;
}, (e) => {
    if (e.config && e.config.url) {
        store.commit('REMOVE_PENDING', e.config.url.hashCode());
    }
    if (e.response && [401, 403].includes(e.response.status)) {
        authenticationService.logout();
      
        import('@/router').then(({ router }) => {
            router.push('/login');
        });
    }
    return Promise.reject(e);
});

export default Api;